'use strict';
angular.module('TurneroApp').component('coAsistenciaAnunciarTurno', {
    bindings: {
        usuario: '<',
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'turnosService',
        '$scope',
        'utilsService',
        '$rootScope',
        'signalrDotNetCoreService',
        'TurneroAppConstant',
        function (turnosService, $scope, utilsService, $rootScope, signalrService, TurneroAppConstant) {
            var ctrl = this;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.limpiarMemoria = function () {
                ctrl.Turnos = null;
                ctrl.personaSeleccionada = null;
                //$rootScope.$broadcast('LimpiarPersonas', null);
            }

            $scope.$on('cambioPersonaSeleccionada', function (event, personaSeleccionada) {
                if (!personaSeleccionada) {
                    ctrl.limpiarMemoria();
                } else {
                    ctrl.Ciudadano = personaSeleccionada

                    utilsService.swalTitle('Procesando datos', 'info');
                    ctrl.getAnunciar(personaSeleccionada)
                }
            });

            ctrl.$onChanges = function () {
                ctrl.limpiarMemoria();
                ctrl.personaConfig = {
                    numero_seccion: 1
                }
            };

            ctrl.anunciarTurno = function (turno) {
                ctrl.turnoDetalles = false;
                if (turno.Permite_Anunciar == 1) {
                    ctrl.funcionAnunciar(turno.Id_Turno)
                } else {
                    swal({
                        title: 'Anunciar Turno',
                        html: "El turno, supera el tiempo de restricción para anunciarse.<br/> ¿Desea continuar?",
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: '#971b2f',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function () {
                        ctrl.funcionAnunciar(turno.Id_Turno)
                    }, function (error) {
                        if (error != 'cancel') {
                            swal.close();
                            sweetAlert("Oops...", "No se ha podido seleccionar el espacio para el turno", "error");
                        }
                    });
                }

            }

            ctrl.funcionAnunciar = function (Id_Turno) {
                utilsService.swalTitle('Anunciando Turno', 'info');
                turnosService.Put_Turno_Anunciar({
                    'id_turno': Id_Turno, 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                }).$promise.then(function (resultado) {
                    console.info("Desde el backend se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ".");
                    //actualizo este turno
                    /*signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, Id_Turno).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ": " + err.toString());
                        });
                    });*/

                    ctrl.personaSeleccionada = null;
                    ctrl.limpiarMemoria();
                    swal.close();
                    swal({
                        title: 'Turno anunciado',
                        html: "El turno fue anunciado correctamente",
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'Aceptar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.mostrarDetalle = function (Id_Turno) {
                ctrl.turnoDetalles = true;
                ctrl.Id_Turno_Detalle = Id_Turno;
            }

            ctrl.getAnunciar = function (persona) {
                var filtro = {
                    Id_Sexo: persona.Datos_RegistroCivil == null ? null : persona.Datos_RegistroCivil.Id_Sexo,
                    Nro_Documento:  persona.Datos_RegistroCivil == null ? persona.Datos_Cidi.N_Ciudadano_Cidi : persona.Datos_RegistroCivil.Nro_Documento,
                    Pai_Cod_Pais:  persona.Datos_RegistroCivil == null ? null : persona.Datos_RegistroCivil.Pai_Cod_Pais == undefined ? null : persona.Datos_RegistroCivil.Pai_Cod_Pais,
                    Id_Numero:  persona.Datos_RegistroCivil == null ? null : persona.Datos_RegistroCivil.Id_Numero,
                    Id_Centro_Atencion: ctrl.centroAtencionSeleccionado.id
                }

                turnosService.Get_Turnos_Para_Anunciar(filtro).$promise.then(function (resultado) {
                    ctrl.Turnos = resultado.Data;
                    swal.close();
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }
        }],
    template: require('./asistencia_anunciarTurno.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/asistencia_anunciarTurnoComponent.js